import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
const release = import.meta.env.VITE_SENTRY_RELEASE as string | undefined;

const isProdHost =
  typeof window !== 'undefined' && window.location.hostname === 'app.sellyt.ai';

const enabled = import.meta.env.PROD && isProdHost && !!dsn;

Sentry.init({
  dsn,
  enabled,
  environment: 'production',
  release,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      // Avoid capturing user input by default.
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  // Low sampling by default (prod-only per enabled flag above)
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0.01,
  replaysOnErrorSampleRate: 1.0,
});
